// extracted by mini-css-extract-plugin
export default {"consentModal":"ConsentModal_consentModal__6FDwm","consentButtons":"ConsentModal_consentButtons__IaJlA","seeMore":"ConsentModal_seeMore__kNtJf","Agree":"ConsentModal_Agree__R69Ii"};